// extracted by mini-css-extract-plugin
export default {"Button":"bS_1iY4EzO2bEy7ESo2H"};